






import { Vue, Component, Prop } from 'vue-property-decorator';
import { getEmailValidateCode } from 'service/api';

@Component
export default class EmailTimerButton extends Vue {
  @Prop(String) readonly email!: string;

  showTime = '';

  counter: NodeJS.Timeout | null = null;

  get isClickable() {
    return (this.email && this.email.match(/^[a-z0-9A-Z]+[-|a-z0-9A-Z._]+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\.)+[a-z]{2,}$/) && !this.counter);
  }

  getCode() {
    if (!this.isClickable) return;
    // TODO 邮箱验证码接口
    getEmailValidateCode({
      email: this.email,
    }).then(() => {
      this.timer();
      this.$message.success('验证码已发送');
    });
  }

  timer() {
    let count = 60;
    this.showTime = `${count}s`;
    this.counter = setInterval(() => {
      count -= 1;
      if (count === 0) {
        if (this.counter) {
          clearInterval(this.counter);
        }
        this.counter = null;
        this.showTime = '';
        return;
      }
      this.showTime = `${count}s`;
    }, 1000);
  }
}
